import { FC, memo, ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import cn from 'classnames';

import styles from './Collapse.module.scss';

interface ICollapseProps {
  header: ReactNode;
  defaultOpen?: true;
}

export const Collapse: FC<ICollapseProps> = memo(({ children, header, defaultOpen }) => {
  const [isActive, setIsActiveState] = useState(false);
  const [setHeight, setHeightState] = useState('0px');
  const contentRef = useRef<HTMLDivElement>(null);
  const calculateHeight = () => {
    const current = contentRef.current || {
      scrollHeight: 0,
    };

    setHeightState(`${current.scrollHeight}px`);
  };

  const toggleAccordion = useCallback(() => {
    setIsActiveState(!isActive);
    let height = '0px';

    if (!isActive && contentRef && contentRef.current) {
      const current = contentRef.current || {
        scrollHeight: 0,
      };

      height = `${current.scrollHeight}px`;
    }
    setHeightState(height);
  }, [isActive]);

  useEffect(() => {
    if (isActive) {
      calculateHeight();
    }
  }, [children, isActive]);

  useEffect(() => {
    if (defaultOpen) {
      setIsActiveState(true);
      calculateHeight();
    }
  }, [defaultOpen]);

  return (
    <div>
      <button type="button" className={styles.Button} onClick={toggleAccordion}>
        {header}
      </button>
      <div
        className={cn(styles.Hidden, { [styles.HiddenIsActive]: isActive })}
        ref={contentRef}
        style={{ maxHeight: `${setHeight}` }}
      >
        {children}
      </div>
    </div>
  );
});
